import { render, staticRenderFns } from "./invest.vue?vue&type=template&id=6f05a087&scoped=true&"
import script from "./invest.vue?vue&type=script&lang=js&"
export * from "./invest.vue?vue&type=script&lang=js&"
import style0 from "./invest.vue?vue&type=style&index=0&id=6f05a087&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05a087",
  null
  
)

export default component.exports